import { IDealerCenterAddress } from '@/interfaces/dealers.interfaces';

const getDealerAddress = (address: IDealerCenterAddress) => {
  const { streetTypeFull, street, house } = address;
  return `${streetTypeFull || ''}${
    street ? `${streetTypeFull ? ' ' : ''}${street}` : ''
  }${house ? `${streetTypeFull || street ? ', ' : ''}${house}` : ''}`;
};

export default getDealerAddress;
